import { differenceInMinutes, parse } from "date-fns";

export const getTimeDifference = (punchInTime, punchOutTime) => {
  const baseDate = new Date();

  const punchIn = parse(punchInTime, "HH:mm", baseDate);
  const punchOut = parse(punchOutTime, "HH:mm", baseDate);

  const totalMinutes = differenceInMinutes(punchOut, punchIn);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return {
    hours: String(hours),
    minutes: String(minutes),
  };
};
